// extracted by mini-css-extract-plugin
export default {"searcBox":"Search_searcBox__s4Gt8"};